import React from "react";

import Alert from "components/alert";
import { floatWithComma2Normalizer } from "validators";

type WaterfallCalculationMessageProps = {
	value: string;
	inlineStyles: React.CSSProperties;
};

export const WaterfallCalculationMessage = ({
	value,
	inlineStyles,
}: WaterfallCalculationMessageProps) => {
	const result = floatWithComma2Normalizer(value, "$");

	return (
		<Alert
			variant="info"
			message={
				<span className={"text-muted text-reset"}>
					Residuals Split Amount (E.g.):
					<span className="text-white pl-3">{result}</span>
				</span>
			}
			className="mb-2 "
			style={inlineStyles}
		/>
	);
};
